export default {
	init() {},
	destroy() {},
	positionUpdated() {
		this.$refs.wrapper.removeAttribute('form-success');
	},
};
